
import { Component, Prop, Vue } from "vue-property-decorator";
import { accountApi } from "@/services/api/account/account";
import AnonymousLayout from "@/layouts/AnonymousLayout.vue";
import { VerifiedEmailCommand } from "@/services/api/models/VerifiedEmailCommand.model";

@Component({
  components: { AnonymousLayout },
})
export default class VerifiedEmail extends Vue {
  $route: any;
  $router: any;
  private message = "";

  async mounted() {
    const userId = this.$route.query.userId as string;
    const code = this.$route.query.code as string;
    this.message = "";

    try {
      const response = await accountApi.verifiedEmail(
        new VerifiedEmailCommand(userId, code)
      );
      await this.$router.push({ name: "Login" });
    } catch (err) {
      if (err.response.status === 400) {
        if (err.response.data.length > 0) {
          let message = "<ul>";
          err.response.data.forEach((item: any) => {
            message += `<li>${item}</li>`;
          });
          message += "</ul>";
          this.message = message;
        }
      }
    }
  }
}
